"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationQueueType = void 0;
var ConversationQueueType;
(function (ConversationQueueType) {
    ConversationQueueType["INTERACTION"] = "INTERACTION";
    ConversationQueueType["NOTIFICATION"] = "NOTIFICATION";
    ConversationQueueType["CONTEXT"] = "CONTEXT";
    ConversationQueueType["LOGGING"] = "LOGGING";
})(ConversationQueueType = exports.ConversationQueueType || (exports.ConversationQueueType = {}));
(function (ConversationQueueType) {
    function getFromTopic(topic) {
        var split = topic.split("/");
        return ConversationQueueType[split[split.length - 1].toUpperCase()];
    }
    ConversationQueueType.getFromTopic = getFromTopic;
})(ConversationQueueType = exports.ConversationQueueType || (exports.ConversationQueueType = {}));
//# sourceMappingURL=ConversationQueueType.js.map